import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import TutorialSistemaContent from './TutorialSistemaContent';

const TutorialSistema = () => {
  return (
    <>
      <HeaderApp />
      <TutorialSistemaContent />
      <Bottom />
    </>
  );
};

export default TutorialSistema;
